import * as z from "zod/v4";

export const upsertGuidance = {
  name: "upsertGuidance" as const,
  input: z.object({ guidance: z.string() }),
  output: z.void(),
};
